import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { ReactComponent as LeftArrowLabel } from '@/assets/icons/left-arrow-label.svg'
import threadsService from '@/app-domains/threads/threads.service'

import './HomeMenu.sass'
import { MenuBottom } from '../MenuBottom/MenuBottom'
import { LabelsButtons } from './components/LabelsButtons/LabelsButtons'
import { BoxesButtons } from './components/BoxesButtons/BoxesButtons'
import { GroupButtons } from './components/GroupButtons/GroupButtons'
import { AddLabelButton } from '../BoxesMenu/components/AddBoxLabelButton/AddLabelButton'
// import { SortMenu } from './components/SortMenu/SortMenu'
import { SortMenu } from '@/components/SortMenu/SortMenu'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import { FixedLabelsButtons } from './components/FixedLabelsButtons/FixedLabelsButtons'
import labelsService from '@/app-domains/labels/labels.service'
import commonsService from '@/services/commons.service'
import { HelperMessage } from '@/components/HelperMessage'
import boxesService from '@/app-domains/boxes/boxes.service'
import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import EditSelectedBoxesModal from './components/EditSelectedBoxesModal/EditSelectedBoxesModal'
import store from '@/core/store'

export function HomeMenu () {
  const [currentBoxes, setCurrentBoxes] = useState([])
  const [selectedLabel, setSelectedLabel] = useState('All')
  const [selectedBox, setSelectedBox] = useState('')
  const [lastRender, setLastRender] = useState(Date.now())
  const [selectedSortType, setSelectedSortType] = useState('Unread')
  const [hideSecondaryMenu, setHideSecondaryMenu] = useState(true)
  const [sideMenuHidden, setSideMenuHidden] = useState(true)
  const [selectedBoxes, setSelectedBoxes] = useState(boxesService.getSelectedBoxesFromStore())

  const hideSideMenu = () => {
    setSideMenuHidden(true)
  }

  /*
    Combination of useEffect + useRenderEvent needed since we are passing the
    state to other components and we need to access the actual state from and only from useEffect.
  */

  useEffect(() => {
    updateSelectedLabel()
  }, [lastRender])

  useRenderEvent(['CONTAINERS:UPDATED'], () => {
    setLastRender(Date.now())
  })

  useRenderEvent(['SIDE_MENU:HIDE'], () => {
    setSideMenuHidden(true)
  })

  useRenderEvent(['SIDE_MENU_SECONDARY:HIDE'], () => {
    setHideSecondaryMenu(true)
  })

  useRenderEvent(['SIDE_MENU:SHOW'], () => {
    setSideMenuHidden(false)
  })

  useRenderEvent(['FILTERS:UPDATED'], () => {
    const activeFilter = threadsService.getCurrentFilter()
    if (activeFilter.type === 'Label') {
      const label = labelsService.findLabelById(activeFilter.value)
      setSelectedLabel(label)
      return updateSelectedLabel()
    }
    if (activeFilter.type === 'Box') {
      const box = boxesService.findBoxbyId(activeFilter.value)
      if (!box || !box.boxlabels) return
      if (box.boxlabels.length === 1) {
        if (selectedLabel.composedid !== box.boxlabels[0].composedid) {
          const label = labelsService.findLabelById(box.boxlabels[0].composedid)
          setSelectedLabel(label)
          return updateSelectedLabel()
        }
      }
      if (box.boxlabels.length === 0) {
        return setSelectedLabel({ name: 'Unlabeled' })
      }
      return setSelectedLabel({ })
    }
  })
  
  const updateSelectedLabel = () => {
    if (selectedLabel === 'All' || selectedLabel === 'Drafts') return
    if (selectedLabel === 'Archived') {
      return setCurrentBoxes(boxesService.getAllStoredBoxes().filter((box) => box.archived))
    }
    const labels = labelsService.getLabelsList()
    if (selectedLabel.role === 'default') {
      const updatedSelectedLabel = labels.find(label => label.role === 'default')
      setSelectedLabel(updatedSelectedLabel)
      setCurrentBoxes(updatedSelectedLabel.boxes.filter(box => !box.archived))
      return
    }
    const updatedSelectedLabel = labels.find(label => label.composedid === selectedLabel.composedid)
    if (updatedSelectedLabel) {
      setSelectedLabel(updatedSelectedLabel)
      setCurrentBoxes(updatedSelectedLabel?.boxes.filter(box => !box.archived))
    } else {
      setSelectedLabel('All')
    }
  }

  const selectArchived = () => {
    commonsService.goToPage('/', true)
    setSelectedLabel('Archived')
    setCurrentBoxes(boxesService.getAllStoredBoxes().filter((box) => box.archived))
    setHideSecondaryMenu(false)
  }

  const selectBox = (box) => {
    setSelectedBox(box.id)
    threadsService.applyFilterFor('Box', box.boxalias || box.boxname, box.composedid)
    setSideMenuHidden(true)
  }
  const selectGroup = (name) => {
    if (name !== 'Drafts') commonsService.goToPage('/', true)
    setSelectedLabel(name)
    setHideSecondaryMenu(true)
  }

  const selectLabel = (label) => {
    commonsService.goToPage('/', true)
    setSelectedLabel(label)
    setSelectedBox(null)
    setCurrentBoxes(label.boxes.filter(box => !box.archived))
    setHideSecondaryMenu(false)
    if (label.role !== 'default') {
      return threadsService.applyFilterFor('Label', label.name, label.composedid, false)
    }
    return threadsService.applyFilterFor('no-label', label.name, 'no-label', false)
  }

  const selectFixedLabel = (label) => {
    commonsService.goToPage('/', true)
    setSelectedLabel(label.name)
    setHideSecondaryMenu(!label.hasChildBoxes)
    threadsService.applyFilterFor(label.filterValue, label.name, label.filterValue, false)
  }

  const selectSortType = (sortType) => {
    setSelectedSortType(sortType)
  }

  useEffect(() => {
    if (window.location.href.toLowerCase().includes('/drafts')) {
      selectGroup('Drafts')
      setHideSecondaryMenu(true)
      return
    }
    const fixedLabels = [
      {
        name: 'All',
        filterValue: 'all',
        type: 'all',
        hasChildBoxes: false,
      }
    ]
    selectFixedLabel(fixedLabels[0])
  }, [])

  useRenderEvent(['CONTAINERS:UPDATED'], updateSelectedLabel)

  function getUserInfo () {
    const myInfo = store.getState().me.me
    return (
      <div className='user-info-container'>
        <div className='user-info-domain'>
          <span className='user-domain' title={myInfo.defaultdomain}>{myInfo.defaultdomain}</span>
        </div>
      </div>
    )
  }

  const getLabelPadding = () => {
    const totalLabels = Object.keys(labelsService.getLabelsFromStore()).length
    const newPadding = 0.04 * totalLabels
    if (newPadding > 0.5) return '0.5rem'
    return `${1 - newPadding}rem`
  }

  function editMultipleBoxesButton () {
    if (selectedBoxes === undefined || selectedBoxes.length === 0) {
      return (
        <></>
      )
    } else {
      return (
        <div className='edit-boxes-div'>
          <Button content={`Edit selected boxes (${selectedBoxes.length})`} click={() => modalService.open(<EditSelectedBoxesModal />)} />
        </div>
      )
    }
  }

  useRenderEvent(['SELECTED_BOXES:UPDATED'], () => {
    setSelectedBoxes(boxesService.getSelectedBoxesFromStore())
  })

  return (
    <div className='aside-content' id='home-menu'>
      <div className={`primary-menu ${sideMenuHidden ? 'hidden-menu' : 'mb-show-menu'}`}>
        <div className="primary-menu-container">
          {commonsService.isMobile() && getUserInfo()}
          <div className="menu-top">
            <div className="menu-top-label">
              <span className="top-label-title"><span className="top-label-title-text">Labels</span></span>
              <HelperMessage
                title='How to Label Your Boxes'
                text={'Labeling a box allows you to easily sort your mail. For instance, grouping all your boxes from Travel web sites will allow you to easily find the messages you need when it comes time to travel. And, if you want you can set the Travel label not to show in your "All" feed so it doesn\'t clutter up your feed until you need it'}
                />
            </div>
            <div className="menu-top-right cursor-pointer">
              <AddLabelButton />
              <HelperMessage
                 title='Create a New Label'
                 text={'It is easy to create a label. Just click the plus sign (+) and type in the label\'s name and click / tap "Create Label". With the new label, you can assign that label to any box in your account'}
              />
            </div>
          </div>
          <div className="menu-content">
            <ul className='scrollable-list labels-group overflow-y-scroll'>
              <FixedLabelsButtons labelPadding={getLabelPadding()} selectedLabel={selectedLabel} selectLabel={selectFixedLabel} />
              <LabelsButtons labelPadding={getLabelPadding()}
                selectedLabel={selectedLabel} selectLabel={selectLabel} currentBoxes={currentBoxes}
                selectedBox={selectedBox} selectBox={selectBox}
              />
              <GroupButtons labelPadding={getLabelPadding()} selectArchived={selectArchived} selectedLabel={selectedLabel} setSelectedLabel={selectGroup} showInLabelsSection={true}/>
            </ul>
            <div className="separator" />
            <ul className='group-buttons'>
              <GroupButtons selectedLabel={selectedLabel} setSelectedLabel={selectGroup} showInLabelsSection={false} />
            </ul>
          </div>
        </div>
        { !commonsService.isMobile() && <MenuBottom className='desktop' /> }

      </div>
      { !commonsService.isMobile() &&
        <div className={classNames('secondary-menu', { hidden: hideSecondaryMenu })}>
          <div className="menu-top">
            <div className="menu-top-label">
              Boxes
            </div>
            <div className="menu-top-right">
              <LeftArrowLabel className='cursor-pointer close-menu' onClick={() => setHideSecondaryMenu(true)} />
            </div>
          </div>
          
          {(currentBoxes || []).length > 0 && <div className="px-xl pb-xl">
            <SortMenu sortValues={['Unread', 'A-Z', 'Created at', 'Updated at']} selectSortType={selectSortType} selectedSortType={selectedSortType} />
          </div>}
          <ul className={classNames('scrollable-list boxes-buttons')} >
            <BoxesButtons selectedLabel={selectedLabel} currentBoxes={currentBoxes} selectedBox={selectedBox} selectBox={selectBox} selectedSortType={selectedSortType} />
          </ul>
          {editMultipleBoxesButton()}
        </div>
      }
      <div className={`side-menu-backdrop ${sideMenuHidden ? 'hidden' : ''}`} onClick={hideSideMenu}></div>
    </div>

  )
}
